import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer } from '../heroSection/heroSection.styled';
import {
  ProcessesContainer,
  SignUpProcessContainer,
  SignUpProcessContent,
  SignUpProcessTitleContainer,
} from './signUpProcess.styled';

const { VITE_PARTNERS_BASE_URL, VITE_CDN_BASE_URL } = getEnv();

const SignUpProcessTitle = () => {
  return (
    <SignUpProcessTitleContainer>
      <h2>
        Ready to streamline your pet care business and join hundreds of pet care businesses who already enjoy Pata?
      </h2>
    </SignUpProcessTitleContainer>
  );
};

export function SignUpProcess() {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };
  // const theme = useTheme();
  return (
    <SignUpProcessContainer>
      <Image
        src={`${VITE_CDN_BASE_URL}/images/image-app-laptop-iphone.webp`}
        alt="Pata Partners app on laptop and iPhone"
        height={2000}
        width={2000}
      />
      <WidthContainer noBackground>
        <SectionContainer title={SignUpProcessTitle}>
          <SignUpProcessContent>
            <ProcessesContainer>
              <ActionContainer>
                <Button onClick={handleSignUpClick}>Sign up today</Button>
                <Button buttonType="secondary" onClick={handleBookDemo}>
                  Book a demo
                </Button>
              </ActionContainer>
            </ProcessesContainer>
          </SignUpProcessContent>
        </SectionContainer>
      </WidthContainer>
    </SignUpProcessContainer>
  );
}
